import { gql, TypedDocumentNode } from "@apollo/client";

import { LogsDownloadUrl, RunCpuProfileDownloadUrlArgs } from "types/generated";

type StackCpuProfileDownloadUrlData = {
  stack: {
    id: string;
    run?: {
      id: string;
      cpuProfileDownloadURL?: Pick<LogsDownloadUrl, "url" | "ongoing"> | null;
    } | null;
  } | null;
};

type StackCpuProfileDownloadUrlVariables = RunCpuProfileDownloadUrlArgs & {
  stackId: string;
  runId: string;
};

export const GET_STACK_CPU_PROFILE_DOWNLOAD_URL: TypedDocumentNode<
  StackCpuProfileDownloadUrlData,
  StackCpuProfileDownloadUrlVariables
> = gql`
  query GetStackCpuProfileDownloadURL($stackId: ID!, $runId: ID!, $state: RunState!) {
    stack(id: $stackId) {
      id
      run(id: $runId) {
        id
        cpuProfileDownloadURL(state: $state) {
          url
          ongoing
        }
      }
    }
  }
`;
